"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSelector = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _Avatar = require("../Avatar");

var _data = require("../../../global-files/data");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var UserSelector = function UserSelector(_ref) {
  var searchLabel = _ref.searchLabel,
      usersArray = _ref.usersArray,
      position = _ref.position,
      id = _ref.id,
      onAssign = _ref.onAssign,
      product = _ref.product,
      assignationTarget = _ref.assignationTarget,
      target = _ref.target,
      concept = _ref.concept,
      index = _ref.index;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      text = _useState2[0],
      setText = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      userFiltered = _useState4[0],
      setUsersFiltered = _useState4[1];

  (0, _react.useEffect)(function () {
    if (usersArray) setUsersFiltered(usersArray);
  }, [usersArray]);

  var onChangeText = function onChangeText(e) {
    setText(e.target.value);
    if (usersArray) setUsersFiltered(usersArray.filter(function (user) {
      return (user.name + " " + user.last_name).toLowerCase().includes(e.target.value.toLowerCase());
    }));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    position: position,
    id: id + "users-list",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "search-cotainer",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFontawesome.FontAwesomeIcon, {
        icon: _freeSolidSvgIcons.faSearch
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: "text",
        className: "search",
        placeholder: searchLabel,
        value: text,
        onChange: onChangeText,
        autoFocus: true
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "selector-container",
      children: userFiltered.length ? userFiltered.map(function (user, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "user-item",
          onClick: function onClick() {
            console.log("onAss", product, user.id_user, " ", assignationTarget, " ", target, index);
            onAssign(product, user.id_user, assignationTarget, target, index);
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
            image: (0, _data.getProfilePicture)(user.id_user, 26, 26),
            altText: "profile image",
            imageType: "medium-image"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            children: [user.name, " ", user.last_name]
          })]
        }, user.id_user + "-" + i);
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Sin usuarios para asignar"
        })
      })
    })]
  });
};

exports.UserSelector = UserSelector;